import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { transformSeasonEntities } from "~pages/SeasonEntities/utilities/transformSeasonEntities";
import type { SeasonEntityResponse } from "~types/seasonEntity";
import { removeEmptyFields } from "~utils/removeEmptyFields";
import { transformListResponse } from "~utils/transformListResponse";

type Props = {
  customParams: Record<string, string | undefined>;
};

export const useFetchSeasonEntities = ({ customParams }: Props) => {
  const request = useApi();
  const { organizationId, sport, seasonId } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["seasonEntities", sport, organizationId, seasonId, customParams],
    queryFn: () =>
      request<SeasonEntityResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/entities?${params.toString()}`).then((response) => {
        const resources = response?.includes?.resources;
        const data = transformSeasonEntities(response?.data || [], resources);

        return transformListResponse({ ...response, data });
      }),
  });
};
